import React, { useEffect } from 'react'
import { Trans, WithTranslation } from 'react-i18next'
import Flex from 'typescript-styled-flex'
import { is } from '../../../components/MediaQuery'
import Button from '../../../components/Template/Button'
import Modal, {
  ModalHeader,
  ModalHeaderLabel,
} from '../../../components/Template/Modal'
import { theme } from '../../../theme'
import { Mixpanel } from '../../../utils/Mixpanel'
import { useSelector } from 'react-redux'
import { getUserId } from '../../../reducers/userAccount/selectors/userAccount'

function DeleteModal({
  open,
  close,
  modalId,
  onDelete,
  events,
  booking,
  iCalendar,
  closeModal,
  roomId,
  t,
}: IDeleteModalProps & IDeleteModalDispatch & WithTranslation) {
  const userId = useSelector(getUserId)
  function deleteRoom() {
    if (!booking) {
      Mixpanel.track('Room Delete Completed', {
        'Room ID': Number(roomId),
      })
      Mixpanel.people.increment(userId, 'Rooms Deleted', 1)
      onDelete()
      closeModal(modalId)
    }
  }

  function onClose() {
    close(modalId)
  }

  const warnings: boolean = events !== 0 || iCalendar || booking

  const isDesktop = is.desktop()

  useEffect(() => {
    Mixpanel.track('Room Delete Screen View', {
      'Room ID': Number(roomId),
    })
  }, [roomId])

  return (
    <Modal
      open={open}
      onClose={onClose}
      deleteModal={true}
      style={{
        marginBottom: isDesktop ? '30vh' : 0,
        maxWidth: isDesktop ? '45em' : '30em',
        minWidth: isDesktop ? '45em' : '10em',
      }}
    >
      <ModalHeader>
        <Flex style={{ fontWeight: 600, width: '100%' }} justifyStart={true}>
          <ModalHeaderLabel>
            <Trans i18nKey={'room_confirm_delete'} />
          </ModalHeaderLabel>
        </Flex>
      </ModalHeader>

      <ul
        style={{
          color: theme.colors.palette.pinkishTan,
          marginTop: '10px',
        }}
      >
        {events > 0 && (
          <li>
            {t('room_confirm_delete_warning').replace('%1$s', String(events))}
          </li>
        )}
        {iCalendar && (
          <Trans
            parent={'li'}
            i18nKey={'icalendar_removing_room_notification'}
          />
        )}
        {booking && (
          <Flex style={{ fontWeight: 500 }}>
            <Trans parent={'li'} i18nKey={'booking_removing_room_title'} />
          </Flex>
        )}

        {!warnings && (
          <Trans parent={'li'} i18nKey={'removing_empty_room_notification'} />
        )}
      </ul>
      <Flex row={true} justifyEnd={true} style={{ marginTop: '10px' }}>
        <Button
          outline={true}
          onClick={onClose}
          style={{ marginRight: '25px' }}
        >
          <Trans i18nKey={'cancel'} />
        </Button>
        <Button disabled={booking} delete={true} onClick={deleteRoom}>
          <Trans i18nKey={'z677_delete_a_room'} />
        </Button>
      </Flex>
    </Modal>
  )
}

export default DeleteModal

export interface IDeleteModalProps {
  open?: boolean
  roomId?: string
  modalId?: boolean
  events: number
  booking: boolean
  iCalendar: boolean
}

export interface IDeleteModalDispatch {
  close: (modalId) => void
  onDelete: () => void
  closeModal?: (modalId) => void
}
